import React, { forwardRef } from "react";
import classNames from "classnames";
import { Error } from "../content";
import RequirementIndicator from "./RequirementIndicator";

const InputText = forwardRef((props, ref) => {
  const {
    id,
    label,
    errorText,
    className = "col-sm-6 pb-2",
    inputMode,
    maxLength,
    tabIndex = 0,
    value = "",
    onChange,
    onBlur,
    onFocus,
    autoComplete = "on",
    hasError = false,
    placeholder = "",
    dataTestId,
    type = "text",
    required = true,
    displayRequirementIndicator = false,
  } = props;
  return (
    <div id={`${id}__container`} className={className}>
      <label className="form-label">
        {label}
        {displayRequirementIndicator && (
          <RequirementIndicator required={required} />
        )}
      </label>
      <input
        id={`${id}-input`}
        name={id}
        className={classNames("form-control form-control-lg", {
          "bg-danger-subtle border-danger-subtle": hasError,
        })}
        type={type}
        inputMode={inputMode}
        maxLength={maxLength}
        tabIndex={tabIndex}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        autoComplete={autoComplete}
        placeholder={placeholder}
        data-testid={dataTestId || id}
        aria-label={`${id}-input`}
        ref={ref}
      />
      {hasError && <Error id={id} text={errorText} />}
    </div>
  );
});

export default InputText;
